export const BASE_URL = process.env.REACT_APP_BASE_URL || 'https://meetapi.deepbluework.com/api_v1/'
// This is still public in a browser bundle. Prefer issuing scoped auth server-side.
export const AUTH = process.env.REACT_APP_API_AUTH_TOKEN || ''
export const serverUrl = process.env.REACT_APP_LIVEKIT_URL || 'wss://livekit.deepbluework.com';
export const waitingTime = 3 // in minutes 